import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { normalize, schema } from 'normalizr';
import { loadIndividualConsultations, exportIndividualConsultations } from './actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';
import SendMessageButton from '../../common/components/message/SendMessageButton';
import {
	sendMessage,
	PARENT_SEND_MESSAGE_REQUEST, PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE
} from '../parents/actions';

class IndividualConsultations extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleListSelectionChange = this.handleListSelectionChange.bind(this);
		this.handleSendMessage = this.handleSendMessage.bind(this);
		this.state = {
			selectedEntities: []
		};
	}

	componentDidMount() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		let filter;
		if (this.props.parentId > 0) {
			filter = { parentId: this.props.parentId };
		} else {
			filter = { ...(this.props.pagination.filter || {}), parentId: null };
		}

		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleFilterSubmit(filter, isExport) {
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.setState({ selectedEntities: [] });
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
		if (isExport)
			this.exportData(filter);
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	handleListSelectionChange(newSelectedEntities) {
		this.setState({ selectedEntities: newSelectedEntities });
	}

	exportData(filter) {
		this.props.exportIndividualConsultations(filter);
	}

	handleSendMessage(values, onSuccess) {
		const { sendMessage } = this.props;
		sendMessage({ ...values, parentIds: this.selectedParentIds() }, onSuccess);
	}

	selectedParentIds() {
		return [...new Set(this.state.selectedEntities.map(item => item.parent.id))]
	}
	normalizeData(consultations) {
		const parent = new schema.Entity('parents', {}, {
			idAttribute: c => c.id
		});
		const consultation = new schema.Entity('individualConsultations', { parent: parent }, {
			idAttribute: p => p.id
		});
		const normalizedData = normalize(consultations, [consultation]);
		return normalizedData;
	}

	renderListActions() {
		const { canSendMessage, t } = this.props;

		const normalizedData = this.normalizeData(this.state.selectedEntities);
		const parents = normalizedData && normalizedData.entities && normalizedData.entities.parents;

		return <React.Fragment>
			{canSendMessage && <SendMessageButton onSendMessage={this.handleSendMessage} to={parents && Object.values(parents).map(p => ({ name: p.fullname, email: p.email }))}
				block={PARENT_SEND_MESSAGE_REQUEST} unblock={[PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE]} />}
		</React.Fragment>
	}

	render() {
		const { isReadonly, individualConsultationTypes, paymentStatusTypes, paymentMethods, parentId, canSendMessage } = this.props;
		return (
			<div>
				{!parentId && <Filter
					onSubmit={this.handleFilterSubmit}
					onReset={this.handleFilterReset}
					individualConsultationTypes={individualConsultationTypes}
					paymentStatusTypes={paymentStatusTypes}
					paymentMethods={paymentMethods} loading={this.props.pagination.loading || this.props.export.loading}/>}
				<List isReadonly={isReadonly} onFetchData={this.handleListEvent} data={this.props.data}
					selectedEntities={this.state.selectedEntities} onSelectionChange={this.handleListSelectionChange}
					listActions={!parentId && this.renderListActions()} canSendMessage={canSendMessage}
					{...this.props.pagination} parentId={parentId}/>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const parentId = ownProps.parentId;
	const {
		pagination,
		exports,
		entities: { individualConsultations },
		auth: { currentUser },
		lookups,
		configuration: { franchisor }
	} = state;

	const individualConsultationsPagination = (parentId ? pagination.individualConsultations[`parent-${parentId}`] : pagination.individualConsultations.all) || { ids: [], pageNumber: 1, pageSize: 10 };
	const individualConsultationsExport = exports.individualConsultations.all || {};

	return {
		data: individualConsultationsPagination.ids.map(id => individualConsultations[id]),
		pagination: individualConsultationsPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'IndividualConsultations'),
		individualConsultationTypes: lookups.individualConsultationTypes,
		paymentStatusTypes: lookups.paymentStatusTypes,
		paymentMethods: lookups.paymentMethods,
		parentId,
		canSendMessage: franchisor.enableAdHocMessages && authUtils.hasPermission(currentUser, 'SendMessage'),
		export: individualConsultationsExport
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadIndividualConsultations,
	exportIndividualConsultations,
	sendMessage,
	initializeFilter: (data, fields) => initialize('individualConsultationsFilter', data, fields)
})(IndividualConsultations);